import axios from "axios";

const API_BASE = "http://localhost:3001";

export async function getTransactions(params = {}) {
  const res = await axios.get(`${API_BASE}/transactions`, { params });
  return res.data;
}

export async function createTransaction(payload) {
  const res = await axios.post(`${API_BASE}/transactions`, payload);
  return res.data;
}